export const locale = {
    lang: 'zh1',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': '網絡公司簡介',
        'TIT_WCP_DAT': '訪問數據',
        'CHAN_INF':'加載信息',
        'HELP':'幫助',
        'EnlaceWCP':'複製鏈接進入公司簡介',
        'ClaveWCP':'複製密碼進入公司簡介',
        'PORDUC_CER':{
          '40':'認證 3.0',
          '1':'證明',
          '20':'認證 2.0',

        },
        'ESTA_WEB_CP':{
          'false':'我不發布',
          'true':'公共',
        },
        'MODAL':{
          'TIT_MOD':'不發表的原因是什麼？',
           'BTN_CONT':'繼續',
           'BTN_CANC':'取消',
           'RAISON_OBLIG': '要繼續，您必須輸入未發表的原因',
           'TIT_CONDI_US':'使用條款',
           'TEX1_CONDI_US':'公司簡介公開後，將與已配置的信息一起發佈在 Great Place To Work(r) 頁面上。Great Place to Work(r) 對內容不承擔任何責任，因為發布的數據是同一家公司在為其準備的平台上上傳的信息的結果。',
           'TEX2_CONDI_US':'此外，公司同意將這些信息上傳到已簽約的各種搜索引擎，以增加對已獲得 Great Place To Work(r) 認證的最佳工作公司的傳播',
           'TEX3_CONDI_US':'公司可能隨時將公司簡介恢復為私人模式，這將導致其不再出現在認證公司列表中，但是 Great Place To Work(r) 將無法刪除 搜索引擎已完成的索引，因此公司名稱可能會在一段時間內繼續出現在 Great Place To Work 使用的不同搜索引擎的搜索結果中。',
           'TEX4_CONDI_US':'發布或不發布此公司簡介由公司全權負責。',
           'REA_TEX_CONDI_US':'要確認，請寫下以下文字',
           'NO_DISPO_ARCHI':'文件不可用',
        }

      }
    }
};
